module.exports = __webpack_public_path__ + "img/member-assets.9c685ae5.svg";